import { render } from "./StorageGetValuePropsCmp.vue?vue&type=template&id=fabdc7f2"
import script from "./StorageGetValuePropsCmp.vue?vue&type=script&lang=js"
export * from "./StorageGetValuePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__